import { Grid } from "@mui/material";
import React from "react";
import { FileBodyTypeEnum } from "../../../../api/file-management";
import { Diagnosis } from "../../../../api/medical-operations";
import { InputField, SelectField } from "../../../../utils/FormFields";
import UploadField from "../../../../utils/FormFields/UploadField";

const DiagnosisForm = ({ diagnoses }: any) => {
  const availableDiagnoses = diagnoses?.map((diagnosis: Diagnosis) => {
    return {
      label: diagnosis.Name,
      value: diagnosis.DiagnosisID,
    };
  });

  return (
    <>
      <Grid
        container
        rowSpacing={4}
        spacing={2}
        sx={{
          pt: 4,
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <Grid container />
        <Grid item xs={12} sm={5}>
          <SelectField name="Diagnoses.DiagnosisID" label="Diagnosis" data={availableDiagnoses} fullWidth />
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={5}>
          <InputField name="Diagnoses.DoctorNotes" label="Doctor Notes" multiline rows={4} fullWidth variant="filled" />
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={2.5}>
          <UploadField
            name="PrescriptionImage"
            label="Prescription Image"
            fullWidth
            fileType={FileBodyTypeEnum.PRESCRIPTIONIMAGE}
          />
        </Grid>
        <Grid item xs={12} sm={11} md={2.5} key="Category">
            <InputField
              name="ImageCategory"
              label="Category"              
              rows={1}
              fullWidth
              variant="filled"
            />
          </Grid>
      </Grid>
    </>
  );
};

export default DiagnosisForm;
